import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { JBColors, JBIcon } from '@bjb-gcrm/gcrm-frontend-components';

export const KycLockMessage = () => {
  const { t } = useTranslation();
  return (
    <Box display="flex" alignItems="center" gap={1} alignContent="center" sx={{ minWidth: 0 }}>
      <Box display="flex" sx={{ flexShrink: 0 }}>
        <JBIcon iconName="lock" fill={JBColors.black} size="xl" />
      </Box>
      <Typography sx={{ pt: '4px', minWidth: 0 }} data-testid="kyc-lock-message">
        {t('accounts.dlm.lock.title')}
      </Typography>
    </Box>
  );
};
